import { get } from 'tools/query'

export const log = (message?: any, ...optionalParams: any[]): void => {
  if (get().debug) {
    console.log(message, ...optionalParams) // tslint:disable-line
  }
}
